import { Button } from '@/components/elements/forms/buttons';
import { SCREEN_VIEW } from '@/constants/analytics';
import useMobileView from '@/hooks/useMobileView';
import useTrackScreenShown from '@/hooks/useTrackScreenShown';
import { _s } from '@/locale';
import { TriggerSource } from '@/types/analytics';
import Modal from './redesign/Modal/Modal';

const LogoutModal = ({
  isOpen,
  onClick,
  onClose,
  triggerSource,
}: {
  isOpen: boolean;
  onClick: () => void;
  onClose: () => void;
  triggerSource?: TriggerSource;
}) => {
  const { isMobileView } = useMobileView();
  const translationKey = `account-settings.logout-modal`;

  useTrackScreenShown({ screen_name: SCREEN_VIEW.LOGOUT_START, initiated_from: triggerSource }, [isOpen], [isOpen]);

  return (
    <Modal isOpen={isOpen}>
      <Modal.Content floating>
        <Modal.Header title={_s(`${translationKey}.title`)} />
        <div className={`gap-sm flex flex-col ${isMobileView ? 'px-lg' : ''}`}>
          <p className="text-black-600">{_s(`${translationKey}.body`)}</p>
        </div>
        <Modal.Footer>
          <Button variant="link" size="sm" onClick={onClick}>
            {_s(`${translationKey}.logout-button`)}
          </Button>
          <Button variant="primary" size="sm" onClick={onClose}>
            {_s(`${translationKey}.cancel-button`)}
          </Button>
        </Modal.Footer>
      </Modal.Content>
    </Modal>
  );
};

export default LogoutModal;
